import { render, staticRenderFns } from "./wf-checkbox-list-with-action-edit.vue?vue&type=template&id=7c5fa93a&scoped=true&"
import script from "./wf-checkbox-list-with-action-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-checkbox-list-with-action-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-checkbox-list-with-action-edit.vue?vue&type=style&index=0&id=7c5fa93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5fa93a",
  null
  
)

export default component.exports